__webpack_require__.p = "/Portfolio_frontend/";